var viLang = {
	
};

export { viLang as default };
